import { videoModel } from "./defaults";

export const kling25 = videoModel("kling-2.5", "Kling 2.5", { start: 1 }, {
  image: "kling-video/v2.5-turbo/standard/image-to-video",
});
